import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { SpinnerService } from '../../../../core/services/spinner.service';
import { InformationDialogData } from '../../../../core/interfaces/information-dialog';
import { InformationDialogs, InformationDialogsGetter } from './information-dialogs.enum';

interface InformationModalData {
  mode: InformationDialogs;
  additionalMessages?: string[];
}

@Component({
  selector: 'app-information-dialog',
  templateUrl: './information-dialog.component.html',
  styleUrls: ['./information-dialog.component.scss']
})
export class InformationDialogComponent implements OnInit {
  populatedData: InformationDialogData;
  hideMessage: boolean = false;
  loaded: boolean = false;
  additionalMessages: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: InformationModalData,
              public dialogRef: MatDialogRef<InformationDialogComponent>,
              private translateService: TranslateService,
              private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.setDialogStyleProperty('0'); // hide dialog while loading
    let load = InformationDialogsGetter.getDialogData(this.data.mode);
    this.additionalMessages = this.data.additionalMessages ?? [];
    setTimeout(() => {
      this.spinnerService.showSpinner();
      this.spinnerService.setSpinnerMessageByKey('spinnerMessages.loading_wait');
    }, 500);
    setTimeout(() => {
      this.setDialogStyleProperty('24px');// show dialog back after loading
      this.loaded = true;
      this.populatedData = load;
      this.spinnerService.hideSpinner();
    }, 2000);
  }

  setDialogStyleProperty(style: string): void{
    if(this.dialogRef.id){
      let elem = document.getElementById(this.dialogRef.id);
      if(elem){
        elem.style.padding = style;
      }
    }

  }
  onClose(event){
    event.stopPropagation();
    this.dialogRef.close(this.hideMessage);
  }

}
